import { i18n } from "@/main";
import moment from "moment";
import { LOCAL_STORAGE_KEYS } from "@/enums/local-storage";
import usersService from "@/services/users";
import serviceHandler from "@/helpers/handlers/service";
import { setCustomValidators } from "@/config/validators";
import { FEATURE_FLAG, isFeatureFlagEnabledForUserAsync } from "@/helpers/posthog";
import { getSessionId } from "@/helpers/auth-session";

export default {
  async loadStripeSubscriptionUiFlag({ commit, rootState, rootGetters }) {
    const sessionId = getSessionId();
    const userId = rootState.company.company.company_user.user_id;
    commit("SET_STRIPE_SUBSCRIPTION_UI_ENABLED", false);
    let enabled = false;
    try {
      enabled = await isFeatureFlagEnabledForUserAsync(
        FEATURE_FLAG.CEN_846_STRIPE_SUBSCRIPTION_UI,
        userId
      );
    } catch {
      // A failed flag lookup must retain the production view.
    }
    const company = rootState.company.company;
    if (
      sessionId === getSessionId() &&
      rootGetters["auth/isAuthenticated"] &&
      (!company || company.company_user.user_id === userId)
    ) {
      commit("SET_STRIPE_SUBSCRIPTION_UI_ENABLED", enabled);
    }
  },
  async changeLanguage({ commit, getters }, payload) {
    i18n.locale = payload.locale;
    setCustomValidators(i18n);

    moment.locale(payload.locale);

    document.documentElement.lang = payload.locale;
    if (
      this.getters["auth/isAuthenticated"] &&
      this.getters["company/isWizardCompleted"]
    ) {
      await serviceHandler(
        usersService.patchUserDetails({
          language: payload.locale
        })
      );
    }
    localStorage.setItem(LOCAL_STORAGE_KEYS.LANGUAGE, JSON.stringify(payload));

    commit("CHANGE_LANGUAGE_HANDLER", payload.locale);
  },
  setLanguage({ commit }, payload) {
    const data = this.getters["settings/languages"].find(
      e => e.locale === payload
    );
    localStorage.setItem(LOCAL_STORAGE_KEYS.LANGUAGE, JSON.stringify(data));
    commit("CHANGE_LANGUAGE_HANDLER", data.locale);
  },
  setActiveMenuGroup({ commit }, payload) {
    commit("SET_ACTIVE_MENU_GROUP_HANDLER", payload);
  },
  openModal({ state, commit }, data) {
    if (state.isModalOpen === true) return;

    commit("SET_MODAL_DATA", data);
    commit("SET_MODAL_STATE", true);
  },

  setVideoModal({ state, commit }, data) {
    commit("SET_VIDEO_MODAL_STATE", data);
  },

  closeModal({ commit }) {
    commit("SET_MODAL_DATA", {});
    commit("SET_MODAL_STATE", false);
  }
};
